<template>
	<layout>
		<template slot="left">
			<publicMenu :list="list" iconUrl="list"></publicMenu>
		</template>
		<template slot="right">
			<router-view></router-view>
		</template>
	</layout>
</template>

<script>
	import layout from "../../components/layout.vue"
	import publicMenu from "../../components/publicMenu.vue"
	export default {
		components: {
			layout,
			publicMenu
		},
		data() {
			return {
				list: []
			}
		},
		created() {
			var a = JSON.parse(localStorage.getItem("cd"))
			console.log(a)
			a.forEach(val => {
				if (val.meta.title == '审批') {
					var b = val.children
					console.log(b)
					this.list = b
					console.log(this.list)
				}
			
			})
			return
			this.$http.get(
				`/api/api/findMenusByRoleIdAndPath?path=${this.$route.matched[1].path}&roleId=${sessionStorage.roleId}`
				).then(res => {
				this.list = res.data.data;
				this.$router.push(this.list[0].bdMenus[0].path);
			})
		}
	}
</script>

<style>
</style>